import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API } from '../../services/axios.service'
import ApiUrls from '../../helper/ApiUrls'

const initialState = {
    data: [],
    status: 'idle',
    error: ''
}

// serverless
// export const fetchLLMList = createAsyncThunk('chat-bots/list/', async (lekeys={}) => {
//     let bots=[];
//     // bots = await Promise.all(await createMultiRandomUser());
//     bots = (await API.post(ApiUrls.BOT_LIST,{lekeys})).data.data.items;
//     console.log('bots',bots);
//     return bots;
// })

export const fetchLLMList = createAsyncThunk('llm/list/', async () => {
    let llms = [];
    // bots = await Promise.all(await createMultiRandomUser());
    llms = (await API.get(ApiUrls.LLM_LIST)).data.data;
    // console.log('llms',llms);
    return llms;
})

export const llmSlice = createSlice({
    name: 'llm',
    initialState,
    reducers: {

    },
    extraReducers: {
        [fetchLLMList.pending]: (state) => {
            state.status = 'loading';
        },
        [fetchLLMList.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            // console.log('bots',action.payload);
            state.data = [undefined, null].includes(action.payload) ? [] : action.payload
        },
        [fetchLLMList.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
    }
})

// Action creators are generated for each case reducer function
export const { resetState } = llmSlice.actions
export default llmSlice.reducer
